module.exports = __webpack_public_path__ + "media/images/writer/home/home-02@2x-9feeba2b19faf38cefff94819a335902.png";